<ng-container *ngFor="let item of items; let i = index">
  <!-- Ítem sin submenú -->
  <li *ngIf="!item.SubItems || item.SubItems.length == 0" class="{{item.Class}}" (click)="closeOffcanvas()">
    <a routerLink="{{item.Url}}" routerLinkActive="active">
      <span> {{item.Title}}</span>
    </a>
  </li>

  <!-- Ítem con submenú -->
  <li *ngIf="item.SubItems && item.SubItems.length > 0" class="{{item.Class}}">
    <button class="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse"
      [attr.data-bs-target]="'#menu' + item.Id" role="button" aria-expanded="false"
      [attr.aria-controls]="'menu' + item.Id">
      {{ item.Title }}
    </button>
    <div class="collapse" [id]="'menu' + item.Id">
      <ul class="btn-toggle-nav list-unstyled" app-menu [items]="item.SubItems"
        [idparent]="'menu' + item.Id">
      </ul>
    </div>
  </li>
</ng-container>
